export default function ConfirmModal({ title = "Підтвердження", children, actions = [] }) {
    return (
        <div className="modal--backdrop modal--confirm">
            <div className="modal d-block" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content rounded-5">
                        <div className="modal-header me-1 ms-1">
                            <h5 className="modal-title">{title}</h5>
                        </div>

                        <div className="modal-body ms-1 me-1">{children}</div>

                        <div className="modal-footer">
                            {actions.map((btn, i) => (
                                <button key={i} className={`btn rounded-5 ${btn.className || "btn-secondary"}`} onClick={btn.onClick}>
                                    {btn.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
